export const currencyMap: { [key: string]: string } = {
  'af': 'AFN',
  'al': 'ALL',
  'dz': 'DZD',
  'as': 'USD',
  'ad': 'EUR',
  'ao': 'AOA',
  'ai': 'XCD',
  'ag': 'XCD',
  'ar': 'ARS',
  'am': 'AMD',
  'au': 'AUD',
  'at': 'EUR',
  'az': 'AZN',
  'bs': 'BSD',
  'bh': 'BHD',
  'bd': 'BDT',
  'bb': 'BBD',
  'by': 'BYN',
  'be': 'EUR',
  'bz': 'BZD',
  'bj': 'XOF',
  'bm': 'BMD',
  'bt': 'BTN',
  'bo': 'BOB',
  'ba': 'BAM',
  'bw': 'BWP',
  'br': 'BRL',
  'bn': 'BND',
  'bg': 'BGN',
  'bf': 'XOF',
  'bi': 'BIF',
  'kh': 'KHR',
  'cm': 'XAF',
  'ca': 'CAD',
  'cv': 'CVE',
  'ky': 'KYD',
  'cf': 'XAF',
  'td': 'XAF',
  'cl': 'CLP',
  'cn': 'CNY',
  'cx': 'AUD',
  'co': 'COP',
  'km': 'KMF',
  'cg': 'XAF',
  'cd': 'CDF',
  'ck': 'NZD',
  'cr': 'CRC',
  'ci': 'XOF',
  'hr': 'EUR',
  'cu': 'CUP',
  'cy': 'EUR',
  'cz': 'CZK',
  'dk': 'DKK',
  'dj': 'DJF',
  'dm': 'XCD',
  'do': 'DOP',
  'ec': 'USD',
  'eg': 'EGP',
  'sv': 'SVC',
  'gq': 'XAF',
  'er': 'ERN',
  'ee': 'EUR',
  'et': 'ETB',
  'fk': 'FKP',
  'fo': 'DKK',
  'fj': 'FJD',
  'fi': 'EUR',
  'fr': 'EUR',
  'gf': 'EUR',
  'pf': 'XPF',
  'ga': 'XAF',
  'gm': 'GMD',
  'ge': 'GEL',
  'de': 'EUR',
  'gh': 'GHS',
  'gi': 'GIP',
  'gr': 'EUR',
  'gl': 'DKK',
  'gd': 'XCD',
  'gp': 'EUR',
  'gu': 'USD',
  'gt': 'GTQ',
  'gn': 'GNF',
  'gw': 'XOF',
  'gy': 'GYD',
  'ht': 'HTG',
  'va': 'EUR',
  'hn': 'HNL',
  'hk': 'HKD',
  'hu': 'HUF',
  'is': 'ISK',
  'in': 'INR',
  'id': 'IDR',
  'ir': 'IRR',
  'iq': 'IQD',
  'ie': 'EUR',
  'im': 'GBP',
  'il': 'ILS',
  'it': 'EUR',
  'jm': 'JMD',
  'jp': 'JPY',
  'je': 'GBP',
  'jo': 'JOD',
  'kz': 'KZT',
  'ke': 'KES',
  'ki': 'AUD',
  'kp': 'KPW',
  'kr': 'KRW',
  'kw': 'KWD',
  'kg': 'KGS',
  'la': 'LAK',
  'lv': 'EUR',
  'lb': 'LBP',
  'ls': 'LSL',
  'lr': 'LRD',
  'ly': 'LYD',
  'li': 'CHF',
  'lt': 'EUR',
  'lu': 'EUR',
  'mk': 'MKD',
  'mg': 'MGA',
  'mw': 'MWK',
  'my': 'MYR',
  'mv': 'MVR',
  'ml': 'XOF',
  'mt': 'EUR',
  'mh': 'USD',
  'mq': 'EUR',
  'mr': 'MRU',
  'mu': 'MUR',
  'yt': 'EUR',
  'mx': 'MXN',
  'fm': 'USD',
  'md': 'MDL',
  'mc': 'EUR',
  'mn': 'MNT',
  'me': 'EUR',
  'ms': 'XCD',
  'ma': 'MAD',
  'mz': 'MZN',
  'mm': 'MMK',
  'na': 'NAD',
  'nr': 'AUD',
  'np': 'NPR',
  'nl': 'EUR',
  'nc': 'XPF',
  'nz': 'NZD',
  'ni': 'NIO',
  'ne': 'XOF',
  'ng': 'NGN',
  'nu': 'NZD',
  'nf': 'AUD',
  'mp': 'USD',
  'no': 'NOK',
  'om': 'OMR',
  'pk': 'PKR',
  'pw': 'USD',
  'ps': 'ILS',
  'pa': 'PAB',
  'pg': 'PGK',
  'py': 'PYG',
  'pe': 'PEN',
  'ph': 'PHP',
  'pn': 'NZD',
  'pl': 'PLN',
  'pt': 'EUR',
  'pr': 'USD',
  'qa': 'QAR',
  'ro': 'RON',
  'ru': 'RUB',
  'rw': 'RWF',
  'sh': 'SHP',
  'kn': 'XCD',
  'lc': 'XCD',
  'vc': 'XCD',
  'ws': 'WST',
  'sm': 'EUR',
  'st': 'STN',
  'sa': 'SAR',
  'sn': 'XOF',
  'rs': 'RSD',
  'sc': 'SCR',
  'sl': 'SLL',
  'sg': 'SGD',
  'sk': 'EUR',
  'si': 'EUR',
  'sb': 'SBD',
  'so': 'SOS',
  'za': 'ZAR',
  'ss': 'SSP',
  'gs': 'GBP',
  'es': 'EUR',
  'lk': 'LKR',
  'sd': 'SDG',
  'sr': 'SRD',
  'sj': 'NOK',
  'sz': 'SZL',
  'se': 'SEK',
  'ch': 'CHF',
  'sy': 'SYP',
  'tw': 'TWD',
  'tj': 'TJS',
  'tz': 'TZS',
  'th': 'THB',
  'tl': 'USD',
  'tg': 'XOF',
  'tk': 'NZD',
  'to': 'TOP',
  'tt': 'TTD',
  'tn': 'TND',
  'tr': 'TRY',
  'tm': 'TMT',
  'tc': 'USD',
  'tv': 'AUD',
  'ug': 'UGX',
  'ua': 'UAH',
  'ae': 'AED',
  'gb': 'GBP',
  'us': 'USD',
  'uy': 'UYU',
  'uz': 'UZS',
  'vu': 'VUV',
  've': 'VES',
  'vn': 'VND',
  'vg': 'USD',
  'vi': 'USD',
  'wf': 'XPF',
  'ye': 'YER',
  'zm': 'ZMW',
  'zw': 'ZWL',
}